import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import data from './data.json';
import FooterItem from './FooterItem';


const Footer = () => {
    return (
        <div className="footer">
            <Container className="container-main">
                <Row >
                    {data.map((item, index) => (
                        <FooterItem key={`footer-${index}`} {...item} />
                    ))}
                </Row>
            </Container>
        </div>
    );
};

export default Footer;
